// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { homePageMyAccountLayoutStyles } from "@conklin/App/Widgets/Layout/HomePageMyAccountSectionLayout";
import { xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

homePageMyAccountLayoutStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: minmax(0, 1fr) minmax(0, 317px);
        gap: 16px 22px;
        grid-template-rows: auto 1fr;
        padding-top: 16px;

        ${xScreen("lte", "md")} {
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 16px 20px;
        }

        ${xScreen("lte", "sm")} {
            grid-template-columns: minmax(0, 1fr);
        }
    `,
};

homePageMyAccountLayoutStyles.accountOverview = {
    css: css`
        grid-column: 1/2;

        ${xScreen("lte", "md")} {
            grid-column: 1 / 3;
        }

        ${xScreen("lte", "sm")} {
            grid-column: 1/2;
        }
    `,
};

homePageMyAccountLayoutStyles.accountTabs = {
    css: css`
        grid-column: 1/2;
        grid-row: 2/3;

        ${xScreen("lte", "sm")} {
            grid-column: 1 / 2;
            grid-row: 3/4;
            margin-top: 16px;
        }
    `,
};

homePageMyAccountLayoutStyles.myProjects = {
    css: css`
        grid-column: 2/3;
        grid-row: 1/3;

        ${xScreen("lte", "md")} {
            grid-row: 2/3;
        }

        ${xScreen("lte", "sm")} {
            grid-row: 2/3;
            grid-column: 1 / 2;
        }
    `,
};
